import { Component, EventEmitter, Output } from '@angular/core';
import { FileDropDirective } from '../file-drop.directive';

@Component({
    selector: 'ell-file-dropzone',
    standalone: true,
    imports: [FileDropDirective],
    templateUrl: './file-dropzone.component.html',
    styleUrl: './file-dropzone.component.scss'
})
export class FileDropzoneComponent {
    @Output()
    addFiles = new EventEmitter<File[]>();

    onFileChange($event: Event) {
        const input = $event.target as HTMLInputElement;
        if (input.files?.length) {
            this.addFileList(input.files);
        }
    }

    addFileList(fileList: FileList) {
        const files: File[] = [];
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList.item(i);
            if (file) {
                files.push(file);
            }
        }
        if (files.length) {
            this.addFiles.emit(files);
        }
    }

}
